import { createSelector } from "reselect"
import { get, chain } from "lodash"
import { getCurrent } from "./exposure"
import { getFavoriteFactors } from "modules/portfolio-root/selectors/portfolios"
import { computeDisplayType } from "helpers/analyze"
import { getModelFactors, getModelCategories } from "selectors/modelMetadata"

export const getDisabled = state => get(state, "modules.securityProfileExposure.disabled")
const getRawDisplayType = state => get(state, "modules.securityProfileExposure.displayType")

function getFactorLabel(factors, id) {
  const factor = get(factors, id, { label: id })
  return factor.overviewLabel || factor.label
}

function getFactorCategory(factors, id) {
  return get(factors, [id, "category"])
}

export const getDisplayType = createSelector(
  [getRawDisplayType, getModelCategories],
  computeDisplayType,
)

export const getAllItems = createSelector(
  [getModelFactors, getCurrent, getDisabled, getFavoriteFactors],
  (factorsMetadata, lastDatum, disabled, favoriteFactors) => {
    let factors = chain(lastDatum)
      .get("factors")
      .map((exposure, id) => ({ id, lastValue: exposure }))
      .value()

    factors = factors.map(factor => ({
      id: factor.id,
      label: getFactorLabel(factorsMetadata, factor.id),
      category: getFactorCategory(factorsMetadata, factor.id),
      favorite: favoriteFactors[factor.id],
      lastValue: factor.lastValue,
      field: `factors.${factor.id}`,
      disabled: !!disabled[factor.id],
    }))

    return factors
  },
)

export const getAllCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => {
    return chain(items)
      .filter(item => item.category === displayType)
      .orderBy(item => Math.abs(item.lastValue), ["desc"])
      .value()
  },
)

export const getOrderedCategoryItems = createSelector(
  [getAllItems, getDisplayType],
  (items, displayType) => {
    return chain(items)
      .filter(item => item.category === displayType)
      .orderBy([item => item.favorite, item => Math.abs(item.lastValue)], ["asc", "desc"])
      .value()
  },
)
